import React from 'react';
import type {NoProps} from 'types';
import {useLocalization} from 'localization';
import {ThesaurusesGate} from 'services/thesaurus';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import {Scene, Spacer} from 'components';
import {AdvancedSearch} from './AdvancedSearch';
import {
  AdvancedSearchContext,
  useAdvancedSearchContextProviderValue,
} from './context/AdvancedSearchContext';

type Props = NoProps;

export const AdvancedSearchScene: React.FC<Props> = () => {
  const {t} = useLocalization();
  const thesaurusIds = useAllThesaurusIds();

  const advancedSearchContextProviderValue =
    useAdvancedSearchContextProviderValue();

  return (
    <AdvancedSearchContext.Provider value={advancedSearchContextProviderValue}>
      <Scene browserTitle={t('appbar.advancedSearch')}>
        <Scene.Header title={t('appbar.advancedSearch')} />
        <Scene.Content>
          <Spacer size={2} />
          <ThesaurusesGate thesauruses={thesaurusIds}>
            <AdvancedSearch />
          </ThesaurusesGate>
        </Scene.Content>
      </Scene>
    </AdvancedSearchContext.Provider>
  );
};
